import { createTabSlice } from '../helpers';

const tabs = [
  {
    label: 'Unseen',
    icon: 'VisibilityOffIcon',
    component: 'Notifications/Unseen',
  },
  {
    label: 'Seen',
    icon: 'VisibilityIcon',
    component: 'Notifications/Seen',
  },
];

export const tabSlice = createTabSlice({ name: 'notifications/tabs', tabs });
